// extracted by mini-css-extract-plugin
export default {"PFSLogo":"PFSLogo_PFSLogo__0Wi4O"};